import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';
import { NumberInput } from '../../common/input';

import ModalHeader from '../common/modal/header';
import ModalFooter from '../common/modal/footer';

import Percentages from './percentages';

const { UI } = Mobi2Go;
const { Order } = Mobi2Go;
const { Price } = Mobi2Go._class.Common;

class TipModal extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        closeModal: PropTypes.func.isRequired,
    };

    constructor() {
        super();

        this.state = {
            total_without_tip: new Price(Order.getTotalWithoutTip()),
            tip: new Price(Order.getTip()),
        };

        Order.bind({
            updateTotal: this.onUpdateState,
            updateTip: this.onUpdateState,
        });
    }

    onUpdateState = () => {
        this.setState({
            total_without_tip: Order.getTotalWithoutTip(),
            tip: Order.getTip(),
        });
    };

    onCloseButtonClick = () => {
        const { closeModal } = this.props;

        closeModal();
    };

    onCancelButtonClick = () => {
        const { closeModal } = this.props;

        Order.log('clicked cancel on tip');
        Order.setTip(0.0);
        closeModal(true);

        UI.trigger('progressForward', 'tip');
    };

    onOkButtonClick = () => {
        const { closeModal } = this.props;

        Order.log('clicked OK on tip');
        closeModal(true);

        UI.trigger('progressForward', 'tip');
    };

    onInputChange = value => {
        Order.setTip(+value);
    };

    onInputKeyDown = e => {
        const ENTER = 13;
        if (e.keyCode === ENTER) {
            this.onOkButtonClick();
        }
    };

    formatInput = value => {
        const { t } = this.props;

        return t('common:price', { price: new Price(value) });
    };

    getTipPercentage = percentage => {
        const { total_without_tip } = this.state;
        const tip = total_without_tip.toFloat() * (percentage / 100);

        return Math.round(tip * 100) / 100;
    };

    setTipPercentage = percentage => {
        Order.log('clicked tip percentage', { tip_percentage: percentage });
        Order.setTip(this.getTipPercentage(percentage), false);
    };

    render() {
        const { t } = this.props;
        const { tip } = this.state;
        const tip_value = tip.toFloat();

        const percentage_options = Order.getSuggestedTipPercentages();
        const exceeds_largest_percentage_option =
            tip_value > this.getTipPercentage(_.last(percentage_options));
        return (
            <div>
                <ModalHeader
                    onClose={this.onCloseButtonClick}
                    headerText={t('header')}
                />

                <div className="m2g-modal-body m2g-order-tip-modal-body">
                    <div className="m2g-order-tip-modal-feedback">
                        <div
                            data-feedback={(() => {
                                if (
                                    !tip_value ||
                                    tip_value <
                                        this.getTipPercentage(
                                            percentage_options[0]
                                        )
                                ) {
                                    return 'none';
                                }

                                if (
                                    tip_value <=
                                    this.getTipPercentage(percentage_options[0])
                                ) {
                                    return 'good';
                                }

                                if (
                                    tip_value <=
                                    this.getTipPercentage(percentage_options[1])
                                ) {
                                    return 'great';
                                }

                                if (
                                    tip_value <=
                                    this.getTipPercentage(percentage_options[2])
                                ) {
                                    return 'fantastic';
                                }

                                return 'amazing';
                            })()}
                            className="m2g-icon m2g-icon--thumbsup m2g-order-tip-modal-feedback-icon"
                        />
                    </div>

                    <div className="m2g-input-container m2g-order-tip-modal-input-container">
                        <NumberInput
                            className="m2g-input m2g-order-tip-modal-input"
                            value={tip_value}
                            formatter={this.formatInput}
                            selectInputOnFocus
                            onChange={this.onInputChange}
                            onKeyDown={this.onInputKeyDown}
                            onFocus={this.onInputFocus}
                        />
                    </div>

                    <Percentages
                        percentage_options={percentage_options}
                        getTipPercentage={this.getTipPercentage}
                        exceeds_largest_percentage_option={
                            exceeds_largest_percentage_option
                        }
                        value={tip_value}
                        onChange={this.setTipPercentage}
                    />
                </div>

                <ModalFooter>
                    <ModalFooter.Right>
                        <button
                            type="button"
                            className="m2g-button m2g-button--fat"
                            onClick={this.onCancelButtonClick}
                        >
                            {t('no_thanks')}
                        </button>

                        <button
                            type="button"
                            className="m2g-button m2g-button--primary m2g-button--fat"
                            onClick={this.onOkButtonClick}
                        >
                            {t('continue')}
                        </button>
                    </ModalFooter.Right>
                </ModalFooter>
            </div>
        );
    }
}

export default forwardRefWithTranslation('order.tip-modal')(TipModal);
